// extracted by mini-css-extract-plugin
export default {"container":"ZJ-z","disabled":"_J-z","bgBlack":"aK-z","content":"bK-z","countdown":"cK-z","topCaption":"dK-z","topHeading":"eK-z","heading":"fK-z","copy":"gK-z"};